import { render, staticRenderFns } from "./ViewCamera.vue?vue&type=template&id=6507f1b6&scoped=true&"
import script from "./ViewCamera.vue?vue&type=script&lang=js&"
export * from "./ViewCamera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6507f1b6",
  null
  
)

export default component.exports